
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, string_type, record_type, option_type, class_type, bool_type, lambda_type, unit_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, NotificationId__get_unwrap, FormState_get_empty, ClientApiResponse$1_$reflection, FormState_$reflection } from "../../Shared/Shared.js";
import { AcceptNotificationDialog, NotificationToolType_$reflection } from "./AcceptNotificationDialog.js";
import { OverviewNotification_$reflection } from "../../Shared/Notification.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { DataTransferObject_PauseAssignmentNotificationDto, AssignmentNotificationId } from "../../Shared/AssignmentNotification.js";
import { unpauseNotification, pauseNotification } from "../../Requests/AssignmentNotification.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { collect, isEmpty, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { now, compare } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { createElement } from "react";
import React from "react";
import { Dialog } from "../../Components/Dialog.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { TextButton } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { useTranslation } from "react-i18next";
import { AbortNotificationDialog, RejectNotificationDialog } from "./RejectNotificationDialog.js";
import Notification_Alarm_2 from "../../../public/assets/icons/Notification_Alarm_2.svg";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

class State extends Record {
    constructor(OnUpdate, IsAcceptDialogOpen, IsRejectDialogOpen, IsPauseDialogOpen, PausedUntilDate, FormState, NotificationToolType) {
        super();
        this.OnUpdate = OnUpdate;
        this.IsAcceptDialogOpen = IsAcceptDialogOpen;
        this.IsRejectDialogOpen = IsRejectDialogOpen;
        this.IsPauseDialogOpen = IsPauseDialogOpen;
        this.PausedUntilDate = PausedUntilDate;
        this.FormState = FormState;
        this.NotificationToolType = NotificationToolType;
    }
}

function State_$reflection() {
    return record_type("Widgets.NotificationArea.State", [], State, () => [["OnUpdate", lambda_type(unit_type, unit_type)], ["IsAcceptDialogOpen", bool_type], ["IsRejectDialogOpen", bool_type], ["IsPauseDialogOpen", bool_type], ["PausedUntilDate", option_type(class_type("System.DateTime"))], ["FormState", FormState_$reflection()], ["NotificationToolType", NotificationToolType_$reflection()]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetIsAcceptDialogOpen", "SetIsRejectDialogOpen", "SetIsPauseDialogOpen", "SetPausedUntilDate", "ConfirmPause", "ConfirmUnpause", "PauseResponse", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.NotificationArea.Msg", [], Msg, () => [[["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", OverviewNotification_$reflection()]], [["Item", OverviewNotification_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function init(notificationToolType, onUpdate) {
    return [new State(onUpdate, false, false, false, undefined, FormState_get_empty(), notificationToolType), Cmd_none()];
}

function assignmentNotificationId(notification) {
    return new AssignmentNotificationId(parse(NotificationId__get_unwrap(notification.Id)));
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.OnUpdate, state.IsAcceptDialogOpen, msg.fields[0], state.IsPauseDialogOpen, state.PausedUntilDate, state.FormState, state.NotificationToolType), Cmd_none()];
        case 2:
            return [new State(state.OnUpdate, state.IsAcceptDialogOpen, state.IsRejectDialogOpen, msg.fields[0], undefined, FormState_get_empty(), state.NotificationToolType), Cmd_none()];
        case 3:
            return [new State(state.OnUpdate, state.IsAcceptDialogOpen, state.IsRejectDialogOpen, state.IsPauseDialogOpen, msg.fields[0], state.FormState, state.NotificationToolType), Cmd_none()];
        case 4: {
            const matchValue = state.PausedUntilDate;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const pausedUntil = matchValue;
                return [new State(state.OnUpdate, state.IsAcceptDialogOpen, state.IsRejectDialogOpen, state.IsPauseDialogOpen, state.PausedUntilDate, FormState__startLoading(state.FormState), state.NotificationToolType), pauseNotification(assignmentNotificationId(msg.fields[0]), new DataTransferObject_PauseAssignmentNotificationDto(pausedUntil), (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(7, [Item_1])))];
            }
        }
        case 5:
            return [new State(state.OnUpdate, state.IsAcceptDialogOpen, state.IsRejectDialogOpen, state.IsPauseDialogOpen, state.PausedUntilDate, FormState__startLoading(state.FormState), state.NotificationToolType), unpauseNotification(assignmentNotificationId(msg.fields[0]), (Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(7, [Item_3])))];
        case 6: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.OnUpdate, state.IsAcceptDialogOpen, state.IsRejectDialogOpen, state.IsPauseDialogOpen, state.PausedUntilDate, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.NotificationToolType), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.OnUpdate, state.IsAcceptDialogOpen, state.IsRejectDialogOpen, false, undefined, FormState_get_empty(), state.NotificationToolType), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg) => {
                    state.OnUpdate();
                })]))];
            }
        }
        case 7:
            return [new State(state.OnUpdate, state.IsAcceptDialogOpen, state.IsRejectDialogOpen, state.IsPauseDialogOpen, state.PausedUntilDate, FormState_get_empty(), state.NotificationToolType), Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(state.OnUpdate, msg.fields[0], state.IsRejectDialogOpen, state.IsPauseDialogOpen, state.PausedUntilDate, state.FormState, state.NotificationToolType), Cmd_none()];
    }
}

function notificationText(t, textForReceiver, notification) {
    const matchValue = notification.NotificationType;
    switch (matchValue) {
        case "toolUserToStorageRequest": {
            const arg_3 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.tool_user_to_storage_request", arg_3);
        }
        case "toolStorageToUserAssignment":
            if (textForReceiver) {
                const arg_5 = {
                    name: notification.EntityName,
                };
                return t("notification.tool_storage_to_user", arg_5);
            }
            else {
                const arg_7 = {
                    name: notification.EntityName,
                    receiver: notification.Receiver,
                    sender: notification.Sender,
                };
                return t("notification.tool_storage_to_user_as_sender", arg_7);
            }
        case "toolUserToUserAssignment": {
            const arg_9 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.tool_user_to_user", arg_9);
        }
        case "toolWithQuantityBackToStorage": {
            const arg_11 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.tool_with_quantity_back_to_storage", arg_11);
        }
        case "toolWithQuantityUserToStorageRequest": {
            const arg_13 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.tool_with_quantity_user_to_storage_request", arg_13);
        }
        case "toolWithQuantityStorageToUserAssignment": {
            const arg_15 = {
                name: notification.EntityName,
            };
            return t("notification.tool_with_quantity_storage_to_user", arg_15);
        }
        case "toolWithQuantityUserToUserAssignment": {
            const arg_17 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.tool_with_quantity_user_to_user", arg_17);
        }
        case "setBackToStorage": {
            const arg_19 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.set_back_to_storage", arg_19);
        }
        case "setUserToStorageRequest": {
            const arg_21 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.set_user_to_storage_request", arg_21);
        }
        case "setStorageToUserAssignment": {
            const arg_23 = {
                name: notification.EntityName,
            };
            return t("notification.set_storage_to_user", arg_23);
        }
        case "setUserToUserAssignment": {
            const arg_25 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.set_user_to_user", arg_25);
        }
        case "consumableStorageToUserAssignment":
            if (textForReceiver) {
                const arg_27 = {
                    name: notification.EntityName,
                };
                return t("notification.consumable_storage_to_user", arg_27);
            }
            else {
                const arg_29 = {
                    receiver: notification.Receiver,
                    sender: notification.Sender,
                };
                return t("notification.consumable_storage_to_user_as_sender", arg_29);
            }
        case "consumableReturnConsumableToStorage": {
            const arg_31 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.consumable_back_to_storage", arg_31);
        }
        case "consumableReturnConsumableToStorageRequest": {
            const arg_33 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.consumable_user_to_storage_request", arg_33);
        }
        case "storageToUserBulk": {
            const arg_35 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.storage_to_user_bulk", arg_35);
        }
        default: {
            const arg_1 = {
                name: notification.EntityName,
                sender: notification.Sender,
            };
            return t("notification.tool_back_to_storage", arg_1);
        }
    }
}

function isNotificationPaused(notification) {
    const matchValue = notification.PausedUntil;
    if (matchValue == null) {
        return false;
    }
    else {
        return compare(matchValue, now()) > 0;
    }
}

function pauseNotificationDialog(t, state, dispatch, notification) {
    let Title, elems;
    const isPaused = isNotificationPaused(notification);
    const componentState = state.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = (isPaused ? t("assignment_notification.unpause_title") : t("assignment_notification.pause_title")), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5", "max-w-xl"])], (elems = toList(delay(() => append(singleton(reactElement("p", {
            children: isPaused ? t("assignment_notification.unpause_description") : t("assignment_notification.pause_description"),
        })), delay(() => append(!isPaused ? singleton(createElement(DatePicker, {
            ComponentState: componentState,
            IsClearable: false,
            Label: t("assignment_notification.paused_until"),
            MinDate: now(),
            OnChange: (date) => {
                dispatch(new Msg(3, [date]));
            },
            TestId: "pause-notification-date-test-id",
            Value: unwrap(state.PausedUntilDate),
        })) : empty(), delay(() => {
            const matchValue = FormState__getValidation(state.FormState, t, "global");
            if (matchValue == null) {
                return empty();
            }
            else {
                return singleton(createElement(ErrorAlert, {
                    Label: matchValue,
                }));
            }
        })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: () => {
                dispatch(new Msg(2, [false]));
            },
            TestId: "close-pause-notification-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: (!isPaused && (state.PausedUntilDate == null)) ? "disabled" : componentState,
            Label: t("general.save"),
            OnClick: () => {
                if (isPaused) {
                    dispatch(new Msg(5, [notification]));
                }
                else {
                    dispatch(new Msg(4, [notification]));
                }
            },
            TestId: "save-pause-notification-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: state.IsPauseDialogOpen,
        OnClose: () => {
            dispatch(new Msg(2, [false]));
        },
        Title: Title,
    }));
}

function pauseNotificationButton(t, dispatch, notification) {
    return createElement(TextButton, {
        ComponentState: "enabled",
        Label: isNotificationPaused(notification) ? t("assignment_notification.unpause") : t("assignment_notification.pause"),
        OnClick: () => {
            dispatch(new Msg(2, [true]));
        },
        TestId: "pause-notification-button-test-id",
        Variant: "blueButton",
    });
}

function NotificationReceiverElement(props) {
    let elems_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.NotificationToolType, props.OnUpdate), update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const t = patternInput_1[0];
    const i18n = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-5", "bg-[#EFF6FF]", "min-w-85", "text-sm", "flex", "flex-row", "p-3.5", "rounded", "w-full"])], (elems_1 = toList(delay(() => append(singleton(createElement(RejectNotificationDialog, {
        Description: notificationText((arg, arg_1) => (i18n.t(arg, arg_1)), true, props.Notification),
        IsOpen: state_1.IsRejectDialogOpen,
        Notification: props.Notification,
        OnClose: () => {
            dispatch(new Msg(1, [false]));
            state_1.OnUpdate();
        },
        OnConfirm: () => {
            dispatch(new Msg(1, [false]));
            state_1.OnUpdate();
        },
    })), delay(() => append(singleton(createElement(AcceptNotificationDialog, {
        Description: notificationText((arg_2, arg_3) => (i18n.t(arg_2, arg_3)), true, props.Notification),
        IsOpen: state_1.IsAcceptDialogOpen,
        Notification: props.Notification,
        NotificationToolType: state_1.NotificationToolType,
        OnClose: () => {
            dispatch(new Msg(0, [false]));
            state_1.OnUpdate();
        },
        OnConfirm: () => {
            dispatch(new Msg(0, [false]));
            state_1.OnUpdate();
        },
    })), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["w-5", "h-5"])], (elems = [Notification_Alarm_2()], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["grow"]),
            children: notificationText((arg_4, arg_5) => (i18n.t(arg_4, arg_5)), true, props.Notification),
        })), delay(() => append(props.CanPause ? append(singleton(pauseNotificationDialog(t, state_1, dispatch, props.Notification)), delay(() => singleton(pauseNotificationButton(t, dispatch, props.Notification)))) : empty(), delay(() => append(singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("notification.accept"),
            OnClick: () => {
                dispatch(new Msg(0, [true]));
            },
            TestId: "",
            Variant: "blueButton",
        })), delay(() => singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("notification.reject"),
            OnClick: () => {
                dispatch(new Msg(1, [true]));
            },
            TestId: "",
            Variant: "redButton",
        }))))))))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function NotificationSenderElement(props) {
    let elems_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.NotificationToolType, props.OnUpdate), update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const t = patternInput_1[0];
    const i18n = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-5", "bg-[#EFF6FF]", "min-w-85", "text-sm", "flex", "flex-row", "p-3.5", "rounded", "w-full"])], (elems_1 = toList(delay(() => append(singleton(createElement(AbortNotificationDialog, {
        Description: notificationText((arg, arg_1) => (i18n.t(arg, arg_1)), false, props.Notification),
        IsOpen: state_1.IsRejectDialogOpen,
        Notification: props.Notification,
        OnClose: () => {
            dispatch(new Msg(1, [false]));
            state_1.OnUpdate();
        },
        OnConfirm: () => {
            dispatch(new Msg(1, [false]));
            state_1.OnUpdate();
        },
    })), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["w-5", "h-5"])], (elems = [Notification_Alarm_2()], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["grow"]),
            children: notificationText((arg_2, arg_3) => (i18n.t(arg_2, arg_3)), false, props.Notification),
        })), delay(() => append(props.CanPause ? append(singleton(pauseNotificationDialog(t, state_1, dispatch, props.Notification)), delay(() => singleton(pauseNotificationButton(t, dispatch, props.Notification)))) : empty(), delay(() => singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: () => {
                dispatch(new Msg(1, [true]));
            },
            TestId: "",
            Variant: "redButton",
        }))))))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function isReturnNotification(notificationType) {
    switch (notificationType) {
        case "toolBackToStorage":
        case "toolUserToStorageRequest":
        case "toolWithQuantityBackToStorage":
        case "toolWithQuantityUserToStorageRequest":
        case "setBackToStorage":
        case "setUserToStorageRequest":
        case "consumableReturnConsumableToStorage":
        case "consumableReturnConsumableToStorageRequest":
            return true;
        default:
            return false;
    }
}

export function NotificationArea(props) {
    let elems;
    let isStorageManager;
    const matchValue = props.UserData.Role;
    switch (matchValue) {
        case "user": {
            isStorageManager = false;
            break;
        }
        default:
            isStorageManager = true;
    }
    if (!isEmpty(props.Notifications)) {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2", "mb-8"])], (elems = toList(delay(() => collect((notification) => toList(delay(() => append((notification.SenderId === props.UserData.UserId) ? singleton(createElement(NotificationSenderElement, {
            CanPause: isStorageManager,
            Notification: notification,
            NotificationToolType: props.NotificationToolType,
            OnUpdate: props.OnUpdate,
        })) : empty(), delay(() => {
            if (notification.ReceiverId === props.UserData.UserId) {
                return singleton(createElement(NotificationReceiverElement, {
                    CanPause: false,
                    Notification: notification,
                    NotificationToolType: props.NotificationToolType,
                    OnUpdate: props.OnUpdate,
                }));
            }
            else if ((props.IsCurrentUserStorageResponsible && isReturnNotification(notification.NotificationType)) && (notification.SenderId !== props.UserData.UserId)) {
                return singleton(createElement(NotificationReceiverElement, {
                    CanPause: isStorageManager,
                    Notification: notification,
                    NotificationToolType: props.NotificationToolType,
                    OnUpdate: props.OnUpdate,
                }));
            }
            else {
                return empty();
            }
        })))), props.Notifications))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return defaultOf();
    }
}

